/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriggerKind } from './trigger-kind';
import {
    TriggerKindFromJSON,
    TriggerKindFromJSONTyped,
    TriggerKindToJSON,
    TriggerKindToJSONTyped,
} from './trigger-kind';
import type { WorkflowAction } from './workflow-action';
import {
    WorkflowActionFromJSON,
    WorkflowActionFromJSONTyped,
    WorkflowActionToJSON,
    WorkflowActionToJSONTyped,
} from './workflow-action';
import type { ConditionalBranch } from './conditional-branch';
import {
    ConditionalBranchFromJSON,
    ConditionalBranchFromJSONTyped,
    ConditionalBranchToJSON,
    ConditionalBranchToJSONTyped,
} from './conditional-branch';

/**
 * Trigger fired when conversation data changes
 * @export
 * @interface ConversationDataChangedTrigger
 */
export interface ConversationDataChangedTrigger {
    /**
     * Discriminator property to identify the trigger type
     * @type {TriggerKind}
     * @memberof ConversationDataChangedTrigger
     */
    kind: TriggerKind;
    /**
     * Action to be executed when trigger happens.
     * @type {WorkflowAction}
     * @memberof ConversationDataChangedTrigger
     */
    action: WorkflowAction | null;
    /**
     * The conditional branches of the workflow.
     * @type {Array<ConditionalBranch>}
     * @memberof ConversationDataChangedTrigger
     */
    branches: Array<ConditionalBranch>;
}



/**
 * Check if a given object implements the ConversationDataChangedTrigger interface.
 */
export function instanceOfConversationDataChangedTrigger(value: object): value is ConversationDataChangedTrigger {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    return true;
}

export function ConversationDataChangedTriggerFromJSON(json: any): ConversationDataChangedTrigger {
    return ConversationDataChangedTriggerFromJSONTyped(json, false);
}

export function ConversationDataChangedTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationDataChangedTrigger {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': TriggerKindFromJSON(json['kind']),
        'action': WorkflowActionFromJSON(json['action']),
        'branches': ((json['branches'] as Array<any>).map(ConditionalBranchFromJSON)),
    };
}

export function ConversationDataChangedTriggerToJSON(json: any): ConversationDataChangedTrigger {
    return ConversationDataChangedTriggerToJSONTyped(json, false);
}

export function ConversationDataChangedTriggerToJSONTyped(value?: ConversationDataChangedTrigger | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': TriggerKindToJSON(value['kind']),
        'action': WorkflowActionToJSON(value['action']),
        'branches': ((value['branches'] as Array<any>).map(ConditionalBranchToJSON)),
    };
}

